import { usePromotionClient, useUserInfo } from '#imports'

export const usePromotionReclaimableReminder = () => {
    const { canUsePlayerFeatures } = useUserInfo()
    const { useGetNextReclaimable } = usePromotionClient()

    return useGetNextReclaimable({ enabled: canUsePlayerFeatures })
}
